import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';

export default {
    name: 'agentTourlink',
    inject: ['$eventBus'],
    components: {
        mvtShifter,
    },
    computed:{
        ...mapGetters('glb', ['glb'])
    },
    data() {
        return {
            isSeller: false
        };
    },
    methods: {
        switchSeller(flag){
            this.isSeller = flag;
        },
        openHotlead(btnText) {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadSup: 'GET STARTED',
                    hotleadTitle: 'Connect with an agent',
                    hotleadType: 'PopupHotleadInAgentProfilePage_seller',
                    buttonText: btnText,
                    showZipcode: true,
                    profileUrl: this.glb.cdnUrl + 'vimages/assignedAgent.jpg',
                },
            });
        },
        show3rdPartyForm(id, url) {
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
              id: id,
              url: url,
              trigger: this.$options.name
            });
        }
    }
};